import React, { useCallback, useState } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';

import SafelyParseHTML from '@src/services/renderEditorText';

import './ContentSummary.scss';

export const ContentSummary = (props) => {
    const { content } = props;

    const [isOpen, setIsOpen] = useState(true);

    const openImgSrc = '/img/expand_collapse/expand-hover.png';
    const collapseImgSrc = '/img/expand_collapse/collapse-hover.png';

    const toggleOpen = useCallback(() => {
        setIsOpen(!isOpen);
    }, [isOpen, setIsOpen]);

    return (
        <Accordion activeKey={isOpen ? 'summary' : null}>
            <Card className="summary rounded-0 p-0 py-3">
                <Accordion.Button
                    as={Card.Header}
                    eventKey="summary"
                    className={classNames('title p-3', { open: isOpen })}
                    onClick={toggleOpen}
                >
                    <img
                        src="/img/icons/summary.svg"
                        height="18"
                        alt=""
                    />
                    <span>Main Points at a Glance</span>
                    <span className="float-end">
                        <img
                            src={isOpen ? collapseImgSrc : openImgSrc}
                            height="18"
                            alt=""
                        />
                    </span>
                </Accordion.Button>
                <Accordion.Collapse eventKey="summary">
                    <Card.Body className="content px-3 py-1">
                        <div>{SafelyParseHTML(content)}</div>
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        </Accordion>
    );
};

ContentSummary.propTypes = {
    content: PropTypes.string,
};

